/**
 * Floating labels for Elementor form fields
 * ==========================================
 * The label acts as a placeholder and floats up when the input is focused
 * or has a value. Uses event delegation so it also works for forms loaded
 * later (Elementor popups, AJAX steps, etc.).
 *
 * Classes toggled on .elementor-field-group:
 *   .is-focused — input currently has focus
 *   .is-filled  — input has a value
 */

const FIELD_SELECTOR = '.elementor-field-group input, .elementor-field-group textarea';

const getGroup = (field) => field.closest('.elementor-field-group');

const updateFilled = (field) => {
    const group = getGroup(field);
    if (!group) return;
    group.classList.toggle('is-filled', field.value.trim() !== '');
};

document.addEventListener('focusin', (e) => {
    if (!e.target.matches(FIELD_SELECTOR)) return;
    const group = getGroup(e.target);
    if (group) group.classList.add('is-focused');
});

document.addEventListener('focusout', (e) => {
    if (!e.target.matches(FIELD_SELECTOR)) return;
    const group = getGroup(e.target);
    if (group) group.classList.remove('is-focused');
    updateFilled(e.target);
});

document.addEventListener('input', (e) => {
    if (!e.target.matches(FIELD_SELECTOR)) return;
    updateFilled(e.target);
});

// Initial pass (covers browser autofill / prefilled values)
const initFloatingLabels = (scope = document) => {
    scope.querySelectorAll(FIELD_SELECTOR).forEach(updateFilled);
};

document.addEventListener('DOMContentLoaded', () => initFloatingLabels());

// Re-run when Elementor (re)renders a form widget
window.addEventListener('elementor/frontend/init', () => {
    if (window.elementorFrontend?.hooks) {
        window.elementorFrontend.hooks.addAction('frontend/element_ready/form.default', ($scope) => {
            initFloatingLabels($scope[0] ?? document);
        });
    }
});
